module.exports = __webpack_public_path__ + "img/bannerTestClimaLaboral.29d24a95.png";